module.exports = __webpack_public_path__ + "img/img171.56368903.png";